import { TRANSFER_TOOL } from "../../../../../../../routes.ts";
import { useSelectedModelsSettingsAndActions } from "../../../../../../boardState/hooks/useSelectedModelsSettingsAndActions.ts";
import { styleTransferSettingsStorage } from "../../../../../../boardState/stores/settings/styleTransferSettingsStorage.ts";
import type { ModelCompatibleTool } from "../../../../../types.ts";

export const useStyleTransferSettings = (boardUuid: string) => {
  const paramsSettings = styleTransferSettingsStorage.useSettings(boardUuid);

  const setSettings = styleTransferSettingsStorage.useSetSettings(boardUuid);

  const { selectedModelsSettings, modelActions, areSelectedModelsValid } =
    useSelectedModelsSettingsAndActions(TRANSFER_TOOL, boardUuid);

  return {
    tool: TRANSFER_TOOL as ModelCompatibleTool,
    settings: {
      ...paramsSettings,
      selectedModels: selectedModelsSettings,
    },
    setSettings,
    modelActions,
    areSelectedModelsValid,
  };
};
